export const styles = {
    app: {
      maxWidth: 480,
      margin: '0 auto',
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    screen: {
      padding: '16px 20px',
      minHeight: '100vh',
    },
    centered: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 24,
      paddingTop: 8,
    },
    headerTitle: {
      fontSize: 17,
      fontWeight: 600,
      color: '#1e293b',
      margin: 0,
    },
    backBtn: {
      background: 'none',
      border: 'none',
      padding: 4,
      color: '#6366f1',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
    },
    dashboardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: 20,
      paddingTop: 8,
    },
    monthLabel: {
      fontSize: 13,
      color: '#64748b',
      margin: 0,
      marginBottom: 2,
    },
    dashboardTitle: {
      fontSize: 28,
      fontWeight: 700,
      color: '#1e293b',
      margin: 0,
    },
    addBtn: {
      width: 44,
      height: 44,
      borderRadius: 12,
      backgroundColor: '#6366f1',
      color: 'white',
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      boxShadow: '0 2px 8px rgba(99, 102, 241, 0.3)',
    },
    addOptions: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      marginTop: 20,
    },
    optionCard: {
      padding: 24,
      backgroundColor: 'white',
      border: '1px solid #e2e8f0',
      borderRadius: 16,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 8,
      cursor: 'pointer',
      transition: 'all 0.2s',
      textAlign: 'center',
    },
    optionIcon: {
      width: 56,
      height: 56,
      borderRadius: 14,
      backgroundColor: '#eef2ff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 4,
    },
    optionTitle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#1e293b',
    },
    optionDesc: {
      fontSize: 13,
      color: '#64748b',
    },
    previewContainer: {
      position: 'relative',
      borderRadius: 16,
      overflow: 'hidden',
      marginTop: 20,
    },
    preview: {
      width: '100%',
      borderRadius: 16,
    },
    uploadingOverlay: {
      position: 'absolute',
      inset: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.8)',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      fontSize: 15,
    },
    spinner: {
      width: 32,
      height: 32,
      border: '3px solid #e2e8f0',
      borderTopColor: '#6366f1',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
    },
    field: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
    },
    label: {
      fontSize: 13,
      fontWeight: 500,
      color: '#475569',
    },
    input: {
      padding: '12px 14px',
      fontSize: 16,
      borderRadius: 10,
      border: '1px solid #e2e8f0',
      backgroundColor: 'white',
      outline: 'none',
      transition: 'border-color 0.2s',
      width: '100%',
      boxSizing: 'border-box',
    },
    amountInput: {
      position: 'relative',
    },
    currency: {
      position: 'absolute',
      left: 14,
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#64748b',
      fontSize: 16,
    },
    select: {
      padding: '12px 14px',
      fontSize: 16,
      borderRadius: 10,
      border: '1px solid #e2e8f0',
      backgroundColor: 'white',
      outline: 'none',
      width: '100%',
      boxSizing: 'border-box',
    },
    row: {
      display: 'flex',
      gap: 12,
    },
    segmentedControl: {
      display: 'flex',
      backgroundColor: '#f1f5f9',
      borderRadius: 10,
      padding: 4,
    },
    segment: {
      flex: 1,
      padding: '10px 16px',
      fontSize: 14,
      fontWeight: 500,
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: 8,
      cursor: 'pointer',
      color: '#64748b',
      transition: 'all 0.2s',
    },
    segmentActive: {
      backgroundColor: 'white',
      color: '#1e293b',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    primaryBtn: {
      padding: '14px 20px',
      fontSize: 15,
      fontWeight: 600,
      backgroundColor: '#6366f1',
      color: 'white',
      border: 'none',
      borderRadius: 12,
      cursor: 'pointer',
      transition: 'background-color 0.2s',
    },
    error: {
      color: '#ef4444',
      fontSize: 14,
      textAlign: 'center',
      margin: 0,
    },
    hint: {
      color: '#f59e0b',
      fontSize: 13,
      margin: 0,
      marginTop: 4,
    },
    receiptCard: {
      backgroundColor: 'white',
      borderRadius: 16,
      padding: 28,
      textAlign: 'center',
      marginBottom: 24,
      border: '1px solid #e2e8f0',
    },
    receiptMerchant: {
      fontSize: 18,
      fontWeight: 600,
      color: '#1e293b',
      marginBottom: 8,
    },
    receiptAmount: {
      fontSize: 36,
      fontWeight: 700,
      color: '#1e293b',
      letterSpacing: '-0.02em',
    },
    receiptDate: {
      color: '#64748b',
      marginTop: 8,
      fontSize: 14,
    },
    summaryCard: {
      backgroundColor: 'white',
      borderRadius: 16,
      padding: 20,
      border: '1px solid #e2e8f0',
    },
    summaryMain: {
      marginBottom: 4,
    },
    summarySpent: {
      fontSize: 32,
      fontWeight: 700,
      color: '#1e293b',
      letterSpacing: '-0.02em',
    },
    summaryBudget: {
      fontSize: 18,
      color: '#94a3b8',
      fontWeight: 500,
    },
    summaryRemaining: {
      fontSize: 14,
      color: '#64748b',
      marginBottom: 16,
    },
    progressTrack: {
      height: 8,
      backgroundColor: '#f1f5f9',
      borderRadius: 4,
      overflow: 'hidden',
    },
    progressTrackSmall: {
      height: 6,
      backgroundColor: '#f1f5f9',
      borderRadius: 3,
      overflow: 'hidden',
    },
    progressFill: {
      height: '100%',
      borderRadius: 4,
      transition: 'width 0.4s ease',
    },
    section: {
      marginTop: 28,
    },
    sectionTitle: {
      fontSize: 15,
      fontWeight: 600,
      color: '#64748b',
      margin: 0,
      marginBottom: 12,
    },
    categoryList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },
    categoryItem: {
      backgroundColor: 'white',
      borderRadius: 12,
      padding: 14,
      border: '1px solid #e2e8f0',
    },
    categoryTop: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 10,
    },
    categoryName: {
      fontSize: 14,
      fontWeight: 500,
      color: '#1e293b',
    },
    categoryAmount: {
      fontSize: 14,
      fontWeight: 600,
      color: '#1e293b',
    },
    categoryLimit: {
      fontWeight: 400,
      color: '#94a3b8',
    },
    recentList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    recentItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: 'white',
      padding: 14,
      borderRadius: 12,
      border: '1px solid #e2e8f0',
    },
    recentLeft: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
    recentMerchant: {
      fontSize: 14,
      fontWeight: 500,
      color: '#1e293b',
    },
    recentCategory: {
      fontSize: 12,
      color: '#64748b',
    },
    recentAmount: {
      fontSize: 15,
      fontWeight: 600,
      color: '#1e293b',
    },
    emptyText: {
      color: '#64748b',
      fontSize: 15,
    },
  };
  
  export function getProgressColor(percent) {
    if (percent > 100) return '#ef4444';
    if (percent > 80) return '#f59e0b';
    return '#10b981';
  }
  
  export function formatMonth(monthStr) {
    const [year, month] = monthStr.split('-');
    const date = new Date(year, parseInt(month) - 1);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }